<mat-spinner mode="indeterminate" [ngClass]="{ isLoading: isLoading }"></mat-spinner>
<div class="onfido_wrapper" [id]="onfidoElementId" [ngClass]="{ isLoading: isLoading }"></div>
